module.exports = __webpack_public_path__ + "img/coverfx1.b4f87568.jpg";